<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }},
        Fortner English
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
